// The bundle's entry: window.cricket, called from the Razor components through JS interop.
import { drawChainViz } from './chain';
import { drawManhattan } from './manhattan';
import { updateOval } from './oval';
import { drawPitchMap } from './pitchmap';
import { sortable } from './sortable';
import type { Sorter } from './sortable';
import { drawWorm } from './worm';

const cricket = {
  oval: (el: HTMLElement, json: string): void => updateOval(el, JSON.parse(json)),
  pitchMap: (el: HTMLElement, json: string): void => { el.innerHTML = drawPitchMap(JSON.parse(json)); },
  chainViz: (el: HTMLElement, json: string): void => {
    const svgs = drawChainViz(JSON.parse(json));
    el.querySelectorAll('.viz').forEach((v, i) => { v.innerHTML = svgs[i] ?? ''; });
  },
  worm: (el: HTMLElement, json: string): void => { el.innerHTML = drawWorm(JSON.parse(json)); },
  manhattan: (el: HTMLElement, json: string): void => { el.innerHTML = drawManhattan(JSON.parse(json)); },
  copy: async (text: string): Promise<boolean> => { try { await navigator.clipboard.writeText(text); return true; } catch { return false; } },
  remember: (key: string, value: string): void => { try { localStorage.setItem(key, value); } catch { /* storage off */ } },
  recall: (key: string): string | null => { try { return localStorage.getItem(key); } catch { return null; } },
  // A list dragged into order: the page's object hears Moved(from, to). Stopped with the handle returned.
  sortable: (el: HTMLElement, target: Parameters<typeof sortable>[1]): Sorter => sortable(el, target),
};

// A line that opens in place closes its neighbour, and a row added to a list pushes its button down (decisions 0029 and 0030). Hold
// what was tapped where it was: scroll by however far it moved, now and as the page redraws in the next moments (the phone app draws
// a little after the tap). One hold at a time, and the reader's own scroll or key ends it.
let stopHolding: (() => void) | undefined;
const takeOver = ['wheel', 'touchmove', 'keydown'] as const;
document.addEventListener('click', e => {
  const held = (e.target as Element | null)?.closest?.('details[name] > summary, [data-hold]');
  if (!held) return;
  stopHolding?.();
  const top = held.getBoundingClientRect().top;
  // Inside the sheet over the match it is the sheet that scrolls, not the page.
  const scroller: { scrollBy(x: number, y: number): void } = held.closest('.match-over') ?? window;
  const hold = (): void => { if (held.isConnected) scroller.scrollBy(0, held.getBoundingClientRect().top - top); };
  const redraws = new MutationObserver(hold);
  redraws.observe(document.body, { childList: true, subtree: true, attributes: true });
  const timer = setTimeout(() => stop(), 400);
  const stop = (): void => {
    redraws.disconnect();
    clearTimeout(timer);
    takeOver.forEach(type => document.removeEventListener(type, stop));
    if (stopHolding === stop) stopHolding = undefined;
  };
  takeOver.forEach(type => document.addEventListener(type, stop, { passive: true }));
  stopHolding = stop;
  setTimeout(hold);
});

declare global { interface Window { cricket: typeof cricket } }
window.cricket = cricket;
